import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-home-smile-2-line text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                  宅宅资源库
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                专为二次元爱好者打造的资源聚合平台，涵盖动漫、漫画、游戏、轻小说等海量宅系资源，一站式满足你的宅文化需求。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-50 mb-4">资源分类</h4>
              <div className="flex flex-col gap-2">
                {[
                  { to: '/category/anime', label: '动漫资源' },
                  { to: '/category/manga', label: '漫画资源' },
                  { to: '/category/game', label: '游戏资源' },
                  { to: '/category/light-novel', label: '轻小说' },
                ].map(item => (
                  <Link key={item.to} to={item.to} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-150 cursor-pointer whitespace-nowrap">
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-50 mb-4">快速链接</h4>
              <div className="flex flex-col gap-2">
                {[
                  { to: '/', label: '首页' },
                  { to: '/about', label: '关于我们' },
                  { to: '/category/music', label: '音乐资源' },
                  { to: '/category/wallpaper', label: '壁纸图包' },
                ].map(item => (
                  <Link key={item.to} to={item.to} className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-150 cursor-pointer whitespace-nowrap">
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-sm font-bold text-background-50 mb-4">关注我们</h4>
              <div className="flex gap-3 mb-4">
                {[
                  { icon: 'ri-qq-line', label: 'QQ群' },
                  { icon: 'ri-telegram-line', label: 'Telegram' },
                  { icon: 'ri-wechat-line', label: '微信' },
                  { icon: 'ri-bilibili-line', label: 'B站' },
                ].map(social => (
                  <a
                    key={social.label}
                    href="#"
                    className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 text-background-300 hover:text-background-50 transition-all duration-200 cursor-pointer"
                    aria-label={social.label}
                    rel="nofollow"
                  >
                    <i className={`${social.icon} text-base`}></i>
                  </a>
                ))}
              </div>
              <p className="text-xs text-background-500">
                联系邮箱：contact@zhazhai.moe
              </p>
            </div>
          </div>

          <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2024-2026 宅宅资源库 Zhazhai.moe - 版权所有
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <a href="#" className="hover:text-background-300 transition-colors duration-150 cursor-pointer whitespace-nowrap" rel="nofollow">用户协议</a>
              <a href="#" className="hover:text-background-300 transition-colors duration-150 cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-background-300 transition-colors duration-150 cursor-pointer whitespace-nowrap" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}